<template>
  <div id="app">
      <div class="container">

        <component-title
        @changeColorApp = "changeColorApp"
        :backgroundColor = "backgroundColor"
        ></component-title>
      
        <div class="row">
      
        <component-control
        :sortBy = "sortBy"
        :sortWay = "sortWay"
        :strSearch = "strSearch"
        @handleSearchControlApp = "handleSearchControlApp"
        @handleClearApp = "handleClearApp"
        @handleSortControlApp = "handleSortControlApp"
        ></component-control>
           
        <component-form
        :isFormShow = "isFormShow"
        :taskEdit = "taskEdit"
        @handleAddTaskAppVue = "handleAddTaskAppVue"
        @handleSubmitApp = "handleSubmitApp"
        @handleUpdateApp = "handleUpdateApp"
        ></component-form>
      
      </div>

      
      <todo-list-table
      :listTask = "listTaskSort"
      @handleDeleteAppVue = "handleDeleteAppVue"
      @handleEditAppMain ="handleEditAppMain"
      ></todo-list-table>
  
    </div>
  </div>
</template>

<script>
import TodoListTable from './components/TodoListTable.vue';
import ComponentTitle from './components/ComponentTitle.vue';
import ComponentControl from './components/ComponentControl.vue';
import ComponentForm from './components/ComponentForm.vue';
import TaskWhateverName from './data/task.js';



export default {
  name: 'app',
  data: function(){
    return {
      // Object data from /data
      listTask: TaskWhateverName,
      isFormShow: false,
      strSearch: "",
      backgroundColor: false,
      sortBy: "Level",
      sortWay: "ASC",
      taskEdit: null
    }
  },
  components: {
    TodoListTable, 
    ComponentTitle,
    ComponentControl,
    ComponentForm
  },
  computed: {
    listTaskSearch: function(){

       // Get the strSearch;
      const {strSearch} = this;
            
      var newListTask = [];

      this.listTask.forEach(function(item, index){

        let lowercaseName = item.taskName.toLowerCase();
       
         if(lowercaseName.includes(strSearch.toLowerCase())){

           newListTask.push(item);
         }        

      }) 
      return newListTask;
    },

    listTaskSort: function(){

      var sortlistTask = [... this.listTaskSearch];

      if(this.sortBy === 'Name'){
          
          sortlistTask.sort(this.compareName);

      }else if(this.sortBy === 'Level'){

          sortlistTask.sort(this.compareLevel);

      }

      return sortlistTask;
    }
  },

  created: function(){

    console.log("Created already: ", TaskWhateverName.length + " tasks");

  },

  methods: {
    
    handleUpdateApp: function(taskUpdateObject){

      console.log("Update App.com", taskUpdateObject);

      //Step 1: Get the ID

      let index = this.listTask.findIndex(function(item){

        return item.id === taskUpdateObject.id;

      });

      // Step 2: If the id is matched, the remove the old id data and insert a new one.
      if(index !== -1){

        this.listTask.splice(index, 1, taskUpdateObject);
        
      }

    },

    handleEditAppMain: function(taskToProp){

      console.log ("Editform", taskToProp);
      
      if(this.isFormShow === false){

        this.isFormShow = true;
      }
      
      this.taskEdit = taskToProp;
      
    },

    handleSubmitApp: function(data){

      this.listTask.push(data);

      this.isFormShow = ! this.isFormShow;

      console.log(this.listTask);
    },

    handleDeleteAppVue: function(dataDelete){
      
      this.listTask = this.listTask.filter(item => item.id !== dataDelete.id);
      
    },
    // callback function for .sort()
    compareName: function(a, b){

      let sortWayValue = null;

      if(this.sortWay === "ASC"){

        sortWayValue = -1;

      }else{

        sortWayValue = 1;

      }

      if(a.taskName < b.taskName){

        return sortWayValue;

      }else if(a.taskName > b.taskName){

        return sortWayValue * -1;

      }else{        

        return 0

      }
    },

    compareLevel: function(a, b){

      let sortWayValue = null;

      if(this.sortWay === "ASC"){

        sortWayValue = -1;

      }else{

        sortWayValue = 1;

      }

      if(a.level < b.level){

        return sortWayValue;

      }else if(a.level > b.level){

        return sortWayValue * -1;

      }else{        

        return 0

      }
      
    },

    handleSortControlApp: function(sortBy, sortWay){

      console.log("App component" + sortBy + "---" + sortWay)
      this.sortBy = sortBy;
      this.sortWay = sortWay;    
    },

    handleAddTaskAppVue: function(){

      this.isFormShow =! this.isFormShow;

      // Reset the data if close from when editing.

      this.taskEdit = null;
      
    },

    handleSearchControlApp: function(data){

      console.log("In Main, input");

      this.strSearch = data;
    },

    handleClearApp: function(){
      this.strSearch = "";
    },

    changeColorApp: function(){

      this.backgroundColor = !this.backgroundColor;

      //let app = document.getElementById("app");

      let app = document.body;

      let headerColor = document.querySelector(".title-header");
      
      if(this.backgroundColor === false){
        app.style.backgroundColor  = "#fff";

        headerColor.style.color = "#000";
      }else{
        //#625a5a
        app.style.backgroundColor  = "#28214a";
        headerColor.style.color = "#fff";
      }
      
    }
  }
}
</script>

<style>

@import url("https://rsms.me/inter/inter.css");

body {
    padding: 10px 0;
    font-family: 'Inter', -system-ui, system-ui, sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue" !important;
}

.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    vertical-align: middle;
}

.container > .row {
    margin-top: 20px;
    margin-bottom: 30px;
}

span.badge-medium {
  padding: 11px 10px;
    margin: 0px 8px;
    font-size: 16px;
    display: inline-block;
    vertical-align: top;
}

@media (max-width: 992px) {
    .add-task {
        margin-top: 50px;
    }
}

/*Customize*/

.btn-primary {
    background-color: #506cf0!important;
}


</style>
